export type VenueRankingMetric = 'live_score' | 'hopper_score';

export type VenueRankingItem = {
  id: string;
  name: string | null;
  slug: string | null;
  avatar_url: string | null;
  score_value: number;
};

export type VenueRankingResponse = {
  city: { id: string; name: string };
  metric: VenueRankingMetric;
  items: VenueRankingItem[];
};

export async function fetchCityVenueRanking(city: string, metric: VenueRankingMetric): Promise<VenueRankingResponse> {
  const params = new URLSearchParams({ metric });
  const response = await fetch(`/api/v1/cities/${encodeURIComponent(city)}/venues/ranking?${params.toString()}`, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`Venue ranking request failed with status ${response.status}`);
  }

  return response.json() as Promise<VenueRankingResponse>;
}
